<script setup>
const gsapTimeline = useGsapTimeline()
const props = defineProps({
  text: String,
  textColor: { type: String, default: '#E7EEE1' },
})

const wordRefs = ref([])

const randomKey = (prefix) => `${prefix}-${Math.random().toString(36).substring(2, 15)}`

const words = computed(() => (props.text || '').split(' '))

const emit = defineEmits(['timeline'])

onMounted(() => {
  const timeline = gsapTimeline({ name: 'HighlightWords' })

  wordRefs.value.forEach((wordRef) =>
    timeline
      .startInvisible(wordRef)
      .to(wordRef, { backgroundColor: '#087E8B', color: '#141414', duration: 0 }, '>')
      .to(wordRef, { backgroundColor: 'transparent', color: props.textColor, duration: 0 }, '>0.2')
  )

  emit('timeline', timeline)
})
</script>

<template>
  <div class="flex relative">
    <div v-for="word in words" :key="randomKey(word)" class="flex text-center">
      <div ref="wordRefs" class="px-3 py-2 mask">
        <span v-html="word" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.mask {
  mask-image: url('../masks/willy-mask-square-flipped.svg');
  mask-size: cover;
  mask-repeat: no-repeat;
}
</style>
